import { ApiCallError, HttpStatus } from "Infrastructure/Api/ApiUtils";
import { getApiV1AuthUserinfoOptions } from "Infrastructure/Api/generated/@tanstack/react-query.gen";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { PageHeaderProvider } from "Shared/Layouts/PageHeaderContext";
import { useQuery } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from "react-router";

export const AuthenticatedRoute = () => {
	const { isLoading, error } = useQuery(getApiV1AuthUserinfoOptions());

	if (isLoading) return <div />;

	if (
		error instanceof ApiCallError &&
		error.status === HttpStatus.Unauthorized
	) {
		return <Navigate to={AppRouting.SignIn.path()} replace />;
	}

	return (
		<ErrorBoundary FallbackComponent={ApplicationErrorPage}>
			<PageHeaderProvider>
				<AuthenticatedLayout />
			</PageHeaderProvider>
		</ErrorBoundary>
	);
};
